import React from 'react';
import { connect } from 'react-redux';
import { t } from 'i18n';

import {
  setActivityModalIsOpen,
  setActivityModalCarePlanId,
  setActivityModalMode,
  setActivityModalActivityType,
  setActivityModalTimeZone,
} from 'Actions/activityModal';

import { Card, AddActionHeader } from 'Components/Base/Card/';
import Loader from 'Components/Base/Loader';

import Form from './Form';
import RepeatedForm from './RepeatedForm';

const i18nOpts = { scope: 'care_plan_action_plan_page.activities_container.forms_card' };

const renderHeaderAction = (onClick) => {
  return (actionWrapper) => {
    return (
      <AddActionHeader
        onClick={() => {
          actionWrapper(onClick);
        }}
      />
    );
  };
};

const renderFormsList = (forms, repeatedForms) => {
  if (forms?.length === 0 && repeatedForms?.length === 0) {
    return <div className="item-pill-section--item-list-empty">{t('empty', i18nOpts)}</div>;
  }

  return (
    <ul>
      {forms.map((form) => {
        const { id, isComplete, formattedDueAt, name } = form;

        return <Form key={id} isComplete={isComplete} formattedDueAt={formattedDueAt} name={name} />;
      })}

      {repeatedForms.map((repeatedForm) => {
        const { id, name, localizedFrequency, formattedTime, until } = repeatedForm;

        return (
          <RepeatedForm
            key={id}
            name={name}
            localizedFrequency={localizedFrequency}
            formattedTime={formattedTime}
            until={until}
          />
        );
      })}
    </ul>
  );
};

const FormsCard = ({
  carePlanId,
  sessionInfo,
  formsCard,
  setActivityModalIsOpen,
  setActivityModalCarePlanId,
  setActivityModalMode,
  setActivityModalActivityType,
  setActivityModalTimeZone,
}) => {
  const { formsCardState, forms, repeatedForms } = formsCard;

  let content;
  switch (formsCardState) {
    case 'LOADING':
      content = <Loader />;
      break;
    case 'ERROR':
      content = <div className="activities-container__error">{t('api_error', i18nOpts)}</div>;
      break;
    case 'MAIN_CONTENT':
      content = renderFormsList(forms, repeatedForms);
      break;
    default:
      content = <div className="activities-container__error">{t('unexpected_error', i18nOpts)}</div>;
      break;
  }

  return (
    <Card
      id='forms'
      title={t('title', i18nOpts)}
      cardContainerClass='activities-card-container'
      collapsable={true}
      renderHeaderAction={
        sessionInfo.canAdd &&
        renderHeaderAction(() => {
          setActivityModalMode('CREATE');
          setActivityModalActivityType('FORM');
          setActivityModalCarePlanId(carePlanId);
          setActivityModalTimeZone(sessionInfo.timeZone);
          setActivityModalIsOpen(true);
        })
      }
    >
      {content}
    </Card>
  );
};

const mapStateToProps = ({ carePlanActionPlanViewPage }) => {
  const { carePlanId, sessionInfo, formsCard } = carePlanActionPlanViewPage;

  return {
    carePlanId,
    sessionInfo,
    formsCard,
  };
};

const mapDispatchToProps = (dispatch) => {
  const dispatchSetActivityModalIsOpen = (dispatch) => {
    return (isOpen) => {
      dispatch(setActivityModalIsOpen(isOpen));
    };
  };

  const dispatchSetActivityModalMode = (dispatch) => {
    return (mode) => {
      dispatch(setActivityModalMode(mode));
    };
  };

  const dispatchSetActivityModalActivityType = (dispatch) => {
    return (activityType) => {
      dispatch(setActivityModalActivityType(activityType));
    };
  };

  const dispatchSetActivityModalCarePlanId = (dispatch) => {
    return (carePlanId) => {
      dispatch(setActivityModalCarePlanId(carePlanId));
    };
  };

  const dispatchSetActivityModalTimeZone = (dispatch) => {
    return (timeZone) => {
      dispatch(setActivityModalTimeZone(timeZone));
    };
  };

  return {
    setActivityModalIsOpen: dispatchSetActivityModalIsOpen(dispatch),
    setActivityModalCarePlanId: dispatchSetActivityModalCarePlanId(dispatch),
    setActivityModalMode: dispatchSetActivityModalMode(dispatch),
    setActivityModalActivityType: dispatchSetActivityModalActivityType(dispatch),
    setActivityModalTimeZone: dispatchSetActivityModalTimeZone(dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormsCard);
